import { compose } from 'redux'

import withEventHandlers from './withEventHandlers'

import UI from './UI'

export default compose(withEventHandlers)(UI)
